import get from "./get.js";
import { checkComponentNameIsValid } from "./util/check.js";
import registry from "./registry.js";
/**
 * Initializes the given element as the class-component.
 * @param name The name of the class component
 * @param el The element to initialize
 * @return
 */
export default (name, el) => {
    checkComponentNameIsValid(name);
    registry[name](el);
    return get(name, el);
};
